import {HeaderNavbarLeftContainerDefaultBox} from "./header-navbar-left-container.default.box";

export const HeaderNavbarLeftContainerBox = HeaderNavbarLeftContainerDefaultBox;
